export enum UserRole {
  Admin = 'admin',
  Broker = 'broker',
  Carrier = 'carrier',
  Client = 'client',
  None = 'None',
  Market = 'market',
}

// Single source for both the /notifications route meta and CanViewNotifications,
// so the guard and the UI entry points can never disagree.
export const NotificationUserRoles: UserRole[] = [UserRole.Admin, UserRole.Broker, UserRole.Client];
